module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAINJREFUeNpi5GlwYCAFMDGQCAZQg56EyvLwZjkBCaI0AFVvi+/30bCxVTAgrAGimp+DZ+mFHUBEQAPQDXDVGRs7qeBpZjYHBWT+xx9f9tw9HaLjZCqjJS8gseXmUQIagODll3dwPY8+vrz84g4BDXA94jxCc89uBtqJLMU4DNISQIABAK6XNANbZWbAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left2.png
// module id = 616
// module chunks = 1 6